import { inject } from '@angular/core';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { Router } from '@angular/router';

import { catchError, throwError } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BancardTokenService } from '../services/bancard-token.service';

export const requestErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const snackBar = inject(MatSnackBar);
  const router = inject(Router);
  const tokenService = inject(BancardTokenService);

  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      if (err.status === 401) {
        tokenService.invalidate();
        snackBar.open(
          'Falha na autenticação. Tente novamente mais tarde.',
          'Fechar',
          {
            verticalPosition: 'top',
            duration: 5000,
          },
        );
        router.navigateByUrl('auth-fallback');
      }

      return throwError(() => err);
    }),
  );
};
